import { ClerkProvider } from "@clerk/clerk-react";
import { RouterProvider } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { resolveClerkPublishableKey } from "./clerk-env";
import { CartAuthSync } from "./components/CartAuthSync";
import "./index.css";
import { RootErrorBoundary } from "./RootErrorBoundary";
import { router } from "./router";

const clerkPk = resolveClerkPublishableKey();

function App() {
  const inner = (
    <>
      <RouterProvider router={router} />
      {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-left" router={router} /> : null}
    </>
  );

  if (!clerkPk) {
    return inner;
  }

  return (
    <ClerkProvider publishableKey={clerkPk}>
      <CartAuthSync />
      {inner}
    </ClerkProvider>
  );
}

const el = document.getElementById("root");
if (!el) {
  throw new Error("root element missing");
}

createRoot(el).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
);
